import { getRequest, postRequest, putRequest } from '@bo-apis/axios';

const getGoodListBySearch = ({ requestBody, pageInfo }) => {
  return postRequest({
    url: 'api/v1/good/search',
    params: pageInfo,
    data: requestBody,
  });
};

const getCatalogueSearch = ({ requestBody, pageInfo }) => {
  return postRequest({
    url: 'api/v1/good/catalogue',
    params: pageInfo,
    data: requestBody,
  });
};

const getCatalogueCountSearch = ({ requestBody }) => {
  return postRequest({
    url: 'api/v1/good/catalogue/count',
    data: requestBody,
  });
};

const getMainStdCategory = (skip = {}) => {
  return getRequest(
    {
      url: `/api/v1/good/category/main`,
    },
    skip
  );
};

const getAssignedStandardCategoryList = ({ form, pageable }) => {
  return postRequest({
    url: `/api/v1/good/category/assigned-standard-category`,
    params: { ...pageable },
    data: { ...form },
  });
};

const getGoodSafetyCertificationList = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/${goodNumber}/safety-certification-list`,
  });
};

const getGoodBase = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/${goodNumber}/base`,
  });
};

const getGoodOrder = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/${goodNumber}/order`,
  });
};

const getGoodCondition = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/${goodNumber}/condition`,
  });
};

const getGood = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/${goodNumber}/good`,
  });
};

const getGoodDisplay = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/${goodNumber}/display`,
  });
};

const getGoodVendor = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/${goodNumber}/vendor`,
  });
};

const getGoodDelivery = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/${goodNumber}/delivery`,
  });
};

const getGoodPrice = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/${goodNumber}/price`,
  });
};

const getGoodItem = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/${goodNumber}/item`,
  });
};

const getGroupGoodBase = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/group/${goodNumber}/base`,
  });
};
const getGroupGoodOrder = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/group/${goodNumber}/order`,
  });
};
const getGroupGood = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/group/${goodNumber}/good`,
  });
};
const getGroupGoodDisplay = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/group/${goodNumber}/display`,
  });
};

const getGroupGoodCondition = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/group/${goodNumber}/condition`,
  });
};

const getGroupGoodVendor = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/group/${goodNumber}/vendor`,
  });
};

const createGoodApproval = (data) => {
  return postRequest({
    url: '/api/v1/good/approval-request',
    data: { ...data },
  });
};

const createGoodApprovalAll = (goodList) => {
  return postRequest({
    url: '/api/v1/good/approval-request/all',
    data: goodList,
  });
};

const getTempGoodBase = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/${goodNumber}/base`,
  });
};

const getTempGoodOrder = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/${goodNumber}/order`,
  });
};

const getTempGoodCondition = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/${goodNumber}/condition`,
  });
};

const getTempGood = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/${goodNumber}/good`,
  });
};

const getTempGoodDisplay = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/${goodNumber}/display`,
  });
};

const getTempGoodVendor = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/${goodNumber}/vendor`,
  });
};

const getTempGoodDelivery = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/${goodNumber}/delivery`,
  });
};

const getTempGoodPrice = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/${goodNumber}/price`,
  });
};

const getTempGroupGoodBase = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/group/${goodNumber}/base`,
  });
};
const getTempGroupGoodOrder = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/group/${goodNumber}/order`,
  });
};
const getTempGroupGood = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/group/${goodNumber}/good`,
  });
};
const getTempGroupGoodDisplay = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/group/${goodNumber}/display`,
  });
};

const getTempGroupGoodCondition = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/group/${goodNumber}/condition`,
  });
};

const getTempGroupGoodVendor = (goodNumber) => {
  return getRequest({
    url: `/api/v1/good/temp/group/${goodNumber}/vendor`,
  });
};

const updateGoodApproval = (data, tempGoodNumber) => {
  return putRequest({
    url: '/api/v1/good/temp/approval-request',
    data: { ...data },
    params: { tempGoodNumber },
  });
};

const getExhibitionRelatedGood = (goodNumber) => {
  return getRequest({
    url: `/api/v1/exhibition/related-good/${goodNumber}`,
  });
};

const getPromotionRelatedGood = (goodNumber) => {
  return getRequest({
    url: `/api/v1/promotion/related-good/${goodNumber}`,
  });
};

const getGoodSiteSubsidiaryList = async (goodNumberList) => {
  const { result } = await postRequest({
    url: '/api/v1/good/list/site-subsidiary',
    data: {
      goodNumberList,
    },
  });

  return result.map((it) => ({
    goodNumber: it.goodNumber,
    siteNumber: it.siteCode,
    subsidiaryCompanyCodeList: it.subsidiaryCompanyCode.join('|'),
  }));
};

const updateGoodRequireForApproveChangeGood = ({ goodNumber, request }) => {
  return putRequest({
    url: `/api/v1/good/${goodNumber}/approval-request`,
    data: { ...request },
  });
};

const updateGoodSiteSubsidiary = (data = []) => {
  return putRequest({
    url: `/api/v1/good/list/approval-request/site-subsidiary`,
    data: data,
  });
};

const getGoodNormalInformationList = async ({ goodNumberList }) => {
  const { result } = await postRequest({
    url: `/api/v1/good/list/normal-information`,
    data: {
      goodNumberList,
    },
  });

  return result.reduce((acc, item) => {
    acc[item.goodNumber] = item;
    return acc;
  }, {});
};

const getGoodShippingAddressList = async ({ goodNumberList }) => {
  const { result } = await postRequest({
    url: `/api/v1/good/list/shipping-address`,
    data: goodNumberList,
  });

  return result.reduce((acc, item) => {
    acc[item.goodNumber] = item;
    return acc;
  }, {});
};

const getGoodMarginRateList = async (virtualVendorNumberList) => {
  const { result } = await postRequest({
    url: 'api/v1/good/list/margin-rate',
    data: { virtualVendorNumberList },
  });
  return result;
};

const updatePriceRequest = async (goodPriceList) => {
  const { result } = await postRequest({
    url: '/api/v1/good/list/approval-request/price',
    data: { goodPriceList },
  });

  return result;
};

const getPriceHistory = async (goodNumber) => {
  const { result } = await getRequest({
    url: `/api/v1/good-history/${goodNumber}/price`,
  });
  return { result };
};

const getItemPriceHistory = async (goodNumber, itemNumber) => {
  const { result } = await getRequest({
    url: `/api/v1/good-history/${goodNumber}/item/${itemNumber}/price`,
  });
  return { result };
};

const getApprovalRequestCount = async (goodNumberList) => {
  const { result } = await postRequest({
    url: '/api/v1/good-request/count/in-progress',
    data: goodNumberList,
  });
  return { result };
};

const cancelApproval = (tempGoodNumber) => {
  return postRequest({
    url: `/api/v1/good/temp/cancel-approval/${tempGoodNumber}`,
  });
};

const getValidationInformationForPrice = async ({ goodNumberList }) => {
  const { result } = await postRequest({
    url: `/api/v1/good/list/approval-request/price/validation`,
    data: goodNumberList,
  });

  return result;
};

export default {
  getGoodListBySearch,
  getCatalogueSearch,
  getCatalogueCountSearch,
  getMainStdCategory,
  getAssignedStandardCategoryList,
  getGoodSafetyCertificationList,
  getGoodBase,
  getGoodOrder,
  getGoodCondition,
  getGood,
  getGoodDisplay,
  getGoodVendor,
  getGoodDelivery,
  getGoodPrice,
  getGoodItem,
  getGroupGoodBase,
  getGroupGoodOrder,
  getGroupGood,
  getGroupGoodDisplay,
  getGroupGoodCondition,
  getGroupGoodVendor,
  createGoodApproval,
  createGoodApprovalAll,
  getTempGoodBase,
  getTempGoodOrder,
  getTempGoodCondition,
  getTempGood,
  getTempGoodDisplay,
  getTempGoodVendor,
  getTempGoodDelivery,
  getTempGoodPrice,
  getTempGroupGoodBase,
  getTempGroupGoodOrder,
  getTempGroupGood,
  getTempGroupGoodDisplay,
  getTempGroupGoodCondition,
  getTempGroupGoodVendor,
  updateGoodApproval,
  getExhibitionRelatedGood,
  getPromotionRelatedGood,
  getGoodSiteSubsidiaryList,
  updateGoodRequireForApproveChangeGood,
  updateGoodSiteSubsidiary,
  getGoodNormalInformationList,
  getGoodShippingAddressList,
  getGoodMarginRateList,
  updatePriceRequest,
  getPriceHistory,
  getItemPriceHistory,
  getApprovalRequestCount,
  cancelApproval,
  getValidationInformationForPrice,
};
